import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  Box,
  MenuItem,
  InputAdornment,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Checkbox,
} from "@mui/material";
import axios from "axios";
import "./Register.css";
import { Snackbar, Alert } from "@mui/material";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Register = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    email_code: "",
    phone: "",
    college_name: "",
    passing_year: "",
    last_year_percentage: "",
    course_name: "",
    skills: "",
    location: "",
    captcha: "",
    resume: null,
  });

  // 👉 ADD HERE
  const cleanText = (value) => {
    return value
      .replace(/^\s+/, "")
      .replace(/\s+$/, "")
      .replace(/\s{2,}/g, " ");
  };

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success", // success | error | info | warning
  });

  const showSnack = (message, severity = "success") => {
    setSnack({
      open: true,
      message,
      severity,
    });
  };

  const [errors, setErrors] = useState({});
  const [emailSent, setEmailSent] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [timer, setTimer] = useState(120);
  const [captchaText, setCaptchaText] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [otpTimerId, setOtpTimerId] = useState(null);
  const [otpLoading, setOtpLoading] = useState(false);
  const [emailCaptcha, setEmailCaptcha] = useState("");
  const [emailCaptchaText, setEmailCaptchaText] = useState("");

  const [jobType, setJobType] = useState("fresher");
  const [usedCaptchaEmails, setUsedCaptchaEmails] = useState({});
  // structure: { email: "USED_CAPTCHA_VALUE" }
  const [educationType, setEducationType] = useState("pursuing");
  // STEP 1: ADD STATE (inside Register component top)

  const [groupSkills, setGroupSkills] = useState([]);
  const [openSkillBox, setOpenSkillBox] = useState(false);

  const [selectedSkills, setSelectedSkills] = useState({
    "Mechatronics / Robotics": [],
    "Cyber Security": [],
    "Software / Digital Engineering": [],
  });

  //   // ✅ Regex
  const nameRegex = /^[A-Za-z]+( [A-Za-z]+)*$/;
  const emailRegex = /^[a-zA-Z0-9._]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
  const phoneRegex = /^[6-9]\d{9}$/;

  const courseRegex = /^[A-Za-z0-9]+([ _\-&\/][A-Za-z0-9]+)*$/;
  const skillsRegex =
    /^([A-Za-z0-9#+-]+( [A-Za-z0-9#+-]+)*)(,\s?[A-Za-z0-9#+-]+( [A-Za-z0-9#+-]+)*)*$/;
  const collegeRegex = /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/;
  const locationRegex = /^[A-Za-z]+([ ,.\-/][A-Za-z]+)*$/;
  const percentageRegex = /^\d{2,3}(\.\d{1,2})?$/;

  const courses = [
    "B.E",
    "B.Tech",
    "M.E",
    "M.Tech",
    "BCA",
    "BCS",
    "BSC CS",
    "BSC CA",
    "MCA",
    "MSC CA",
    "MSC CS",
    "B.Sc IT",
    "M.Sc IT",
    "BSC-Cyber Security",
    "BSC-Data Science",
    "MSc Cyber Security",
    "MSc Electronics",
  ];

  const semesters = [
    "Sem I",
    "Sem II",
    "Sem III",
    "Sem IV",
    "Sem V",
    "Sem VI",
    "Sem VII",
    "Sem VIII",
  ];
  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    let interval = null;

    if (emailSent && timer > 0 && !emailVerified) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0) {
      setEmailSent(false);
    }

    return () => clearInterval(interval);
  }, [emailSent, timer, emailVerified]);

  const drawCaptcha = (text, canvasId) => {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    // Background
    ctx.fillStyle = "#cfe3e3";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // 👉 Random font styles (important)
    const fonts = [
      "Georgia",
      "Courier New",
      "Comic Sans MS",
      "Verdana",
      "Times New Roman",
    ];

    text.split("").forEach((char, i) => {
      const fontSize = 14 + Math.random() * 4;
      const fontFamily = fonts[Math.floor(Math.random() * fonts.length)];

      ctx.font = `${fontSize}px ${fontFamily}`;
      ctx.fillStyle = "#1a237e";

      const x = 10 + i * 18;
      const y = 25 + Math.random() * 6;

      // 👉 Strong rotation (key for distorted look)
      const angle = (Math.random() - 0.5) * 1.2;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);

      // 👉 Shadow (gives depth like your 1st image)
      ctx.shadowColor = "rgba(28, 26, 26, 0.3)";
      ctx.shadowBlur = 2;

      // 👉 Stroke + fill (makes it rough)
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 1;

      ctx.strokeText(char, 0, 0);
      ctx.fillText(char, 0, 0);

      ctx.restore();
    });

    // 👉 Curved random lines (important for captcha style)
    for (let i = 0; i < 3; i++) {
      ctx.strokeStyle = "#555";
      ctx.beginPath();
      ctx.moveTo(0, Math.random() * 60);

      ctx.bezierCurveTo(
        Math.random() * 200,
        Math.random() * 60,
        Math.random() * 200,
        Math.random() * 60,
        200,
        Math.random() * 60,
      );

      ctx.stroke();
    }

    // 👉 Noise dots
    for (let i = 0; i < 40; i++) {
      ctx.fillStyle = "#999";
      ctx.beginPath();
      ctx.arc(Math.random() * 200, Math.random() * 60, 1, 0, Math.PI * 2);
      ctx.fill();
    }
  };

  const generateEmailCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789@#$%&";
    let result = "";

    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    setEmailCaptchaText(result);
    setEmailCaptcha(""); // ✅ clear input

    setErrors((prev) => ({
      ...prev,
      emailCaptcha: "", // ✅ clear error
    }));

    setTimeout(() => drawCaptcha(result, "emailCaptchaCanvas"), 100);
  };

  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789@#$%&*!?";
    let result = "";

    for (let i = 0; i < 7; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    setCaptchaText(result);

    setTimeout(() => drawCaptcha(result, "mainCaptchaCanvas"), 100);
  };

  useEffect(() => {
    generateCaptcha();
    generateEmailCaptcha(); // 👈 ADD
  }, []);

  const validateField = (name, value) => {
    let error = "";

    if (name === "first_name" || name === "last_name") {
      if (!value) {
        error = "Required";
      } else if (value.length < 2 || value.length > 30) {
        error = "Min 2, Max 30 characters";
      } else if (!nameRegex.test(value)) {
        error = "Invalid Name";
      }
    }

    if (name === "email") {
      if (!value) error = "Required";
      else if (value.length > 50) error = "Max 50 characters";
      else if (!emailRegex.test(value)) error = "Invalid email";
    }

    if (name === "phone") {
      if (!value) error = "Required";
      else if (!/^[6-9][0-9]{9}$/.test(value)) {
        error = "Enter valid 10-digit phone number";
      }
    }
    if (name === "college_name") {
      if (!value) {
        error = "Required";
      } else if (value.length > 100) {
        error = "Max 100 characters";
      } else if (value.trim().length < 2) {
        error = "Minimum 2 characters required";
      } else if (!/[A-Za-z]/.test(value)) {
        error = "Must contain at least one letter";
      } else if (!/^[A-Za-z0-9]+([ ,.\-/][A-Za-z0-9]+)*$/.test(value)) {
        error = "alphanumeric, comma, .,- and / allowed";
      }
    }

    if (name === "passing_year") {
      if (!value) error = "Select passing year";
    }

    if (name === "last_year_percentage") {
      if (!value) {
        return "";
      } else if (!percentageRegex.test(value)) {
        error = "Minimum 2 digits required ";
      } else if (parseFloat(value) < 10 || parseFloat(value) > 100) {
        error = "Must be between 10–100";
      }
    }

    //  if (name === "course_name") {
    //   if (!value) error = "Required";
    //   else if (value.length > 50) error = "Max 50 characters";
    //   else if (!courseRegex.test(value)) error = "Invalid course name";
    // }

    if (name === "course_name") {
      if (!value) error = "Please select a course";
    }

    if (name === "location") {
      if (!value) {
        error = "Required";
      } else if (value.trim().length < 2) {
        error = "Minimum 2 characters required";
      } else if (value.length > 100) {
        error = "Max 100 characters";
      } else if (!/^[A-Za-z1-9]+([ ,.\-/][A-Za-z]+)*$/.test(value)) {
        error = "Only letters,comma,allowed";
      }
    }

    if (name === "skills") {
      if (!value) error = "Required";
      else if (!skillsRegex.test(value)) {
        error = "alphanumeric, +, #, - and , allowed";
      }
    }

    if (name === "resume") {
      if (!value) {
        error = "Resume required";
      } else {
        const allowed = ["pdf", "doc", "docx"];
        const ext = value.name.split(".").pop().toLowerCase();

        if (!allowed.includes(ext)) {
          error = "Only PDF, DOC, DOCX allowed";
        } else if (value.size > 2 * 1024 * 1024) {
          error = "File size must be less than 2MB";
        }
      }
    }

    if (name === "captcha") {
      if (!value) error = "Required";
      else if (value !== captchaText) error = "Captcha mismatch";
    }

    if (name === "emailCaptcha") {
      if (!value) error = "Required";
      else if (value !== emailCaptchaText) {
        error = "Captcha mismatch";
      }
    }
    //     if (name === "current_sem") {
    //   if (!value) error = "Please select semester";
    // }
    if (name === "experience") {
      if (!value) {
        error = "Required";
      } else if (!/^\d{1,2}$/.test(value)) {
        error = "Only numbers allowed (max 2 digits)";
      } else if (parseInt(value) < 1 || parseInt(value) > 20) {
        error = "Min 1 Year Experience is required";
      }
    }

    if (name === "skills") {
      if (!value || value.trim() === "") {
        error = "Select at least one skill";
      }
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    let updatedValue = value;

    if (name === "resume") {
      const file = files[0];
      updatedValue = file;

      const error = validateField(name, file);

      setErrors((prev) => ({
        ...prev,
        [name]: error,
      }));

      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));

      return; // ✅ stop further processing
    }

    // ✅ FIX: apply replace ONLY if value is string
    if (
      typeof value === "string" &&
      name !== "resume" &&
      name !== "phone" &&
      name !== "email_code"
    ) {
      updatedValue = value.replace(/\s{2,}/g, " ").trimStart();
    }

    // Phone restriction
    if (name === "phone") {
      updatedValue = value.replace(/[^0-9]/g, "").slice(0, 10);
    }
    if (name === "captcha") {
      updatedValue = value.slice(0, captchaText.length);
    }

    // Percentage restriction
    if (name === "last_year_percentage") {
      updatedValue = value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1")
        .slice(0, 6); // prevents long values like 999999
    }
    if (name === "experience") {
      updatedValue = value
        .replace(/[^0-9]/g, "") // only numbers
        .slice(0, 2); // max 2 digits (00–99)
    }

    // Skills restriction
    if (name === "skills") {
      updatedValue = value
        .replace(/[^A-Za-z0-9,#\-\+\s]/g, "") // allowed chars
        .replace(/\s*,\s*/g, ", ") // clean comma spacing
        .replace(/\s{2,}/g, " ") // ❗ only one space
        .trimStart(); // ❗ no leading space
    }
    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    const error = validateField(name, updatedValue);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const sendEmailCode = async () => {
    const captchaError = validateField("emailCaptcha", emailCaptcha);

    if (captchaError) {
      setErrors((prev) => ({ ...prev, emailCaptcha: captchaError }));
      return;
    }

    // ✅ CHECK: captcha already used for this email
    if (usedCaptchaEmails[formData.email] === emailCaptchaText) {
      showSnack(
        "Captcha already used for this email. Refresh captcha.",
        "error",
      );
      return;
    }

    const err = validateField("email", formData.email);

    if (err) {
      setErrors((prev) => ({ ...prev, email: err }));
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/api/send-otp-mail/`, {
        email: formData.email,
      });

      // ✅ MARK captcha used for this email (ADD HERE)
      setUsedCaptchaEmails((prev) => ({
        ...prev,
        [formData.email]: emailCaptchaText,
      }));

      setEmailSent(true);
      setTimer(180);
      showSnack("Verification code sent to email", "success");
    } catch {
      showSnack("Error sending OTP", "error");
    }
  };

  const handleOtpChange = (e) => {
    let value = e.target.value;
    // ✅ Allow only numbers + restrict to 6 digits
    value = value.replace(/[^0-9]/g, "").slice(0, 6);

    setFormData((prev) => ({
      ...prev,
      email_code: value,
    }));

    // clear old timer
    if (otpTimerId) clearTimeout(otpTimerId);

    // debounce API call
    const timer = setTimeout(() => {
      if (value.length === 6) {
        verifyEmail(value);
      }
    }, 700);

    setOtpTimerId(timer);
  };
  const verifyEmail = async (otpValue) => {
    setOtpLoading(true); // ✅ START LOADING

    try {
      await axios.post(`${API_BASE_URL}/api/verify-otp/`, {
        email: formData.email,
        code: otpValue,
      });

      setEmailVerified(true);
      showSnack("Email Verified Successfully", "success");
    } catch {
      setEmailVerified(false);
      showSnack("Invalid OTP Code", "error");
    } finally {
      setOtpLoading(false); // ✅ STOP LOADING
    }
  };
  const checkAllValid = () => {
    // always required
    const baseFields = [
      "first_name",
      "last_name",
      "email",
      "phone",
      "location",
      "captcha",
    ];

    for (let field of baseFields) {
      if (!formData[field]) return false;
      if (validateField(field, formData[field])) return false;
    }

    // email must be verified
    if (!emailVerified) return false;

    // education must be selected
    if (!educationType) return false;

    // ---------------- PURSUING ----------------
    if (educationType === "pursuing") {
      if (!formData.college_name) return false;
      // if (!formData.current_sem) return false;
      // if (!formData.last_year_percentage) return false;
      if (!formData.course_name) return false;
    }

    // ---------------- COMPLETED ----------------
    if (educationType === "completed") {
      if (!jobType) return false;

      if (!formData.passing_year) return false;
      if (!formData.course_name) return false;
      if (!formData.skills) return false;

      if (jobType === "experienced") {
        if (!formData.experience) return false;
      }
    }

    // resume always required
    if (!formData.resume) return false;

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    // ---------------- BASE FIELDS ----------------
    const baseFields = [
      "first_name",
      "last_name",
      "email",
      "phone",
      "location",
      "captcha",
    ];

    baseFields.forEach((key) => {
      const err = validateField(key, formData[key]);
      if (err) newErrors[key] = err;
    });

    // ---------------- EDUCATION VALIDATION ----------------
    if (!educationType) {
      showSnack("Select education type", "error");
      return;
    }

    if (educationType === "pursuing") {
      if (!formData.college_name) newErrors.college_name = "Required";
      // if (!formData.current_sem) newErrors.current_sem = "Required";
      // if (!formData.last_year_percentage)
      //   newErrors.last_year_percentage = "Required";
      if (!formData.course_name) newErrors.course_name = "Required";
    }

    if (educationType === "completed") {
      if (!jobType) {
        showSnack("Select job type", "error");
        return;
      }

      if (!formData.passing_year) newErrors.passing_year = "Required";
      if (!formData.course_name) newErrors.course_name = "Required";
      if (!formData.skills) newErrors.skills = "Required";

      if (jobType === "experienced") {
        if (!formData.experience) newErrors.experience = "Required";
      }
    }

    // ---------------- RESUME ----------------
    if (!formData.resume) {
      newErrors.resume = "Resume required";
    }

    setErrors(newErrors);

    // ❌ STOP IF ERRORS EXIST
    if (Object.keys(newErrors).length > 0) {
      showSnack("Please fix errors before submitting", "error");
      return;
    }

    // ---------------- EMAIL VERIFIED ----------------
    if (!emailVerified) {
      showSnack("Please verify your email", "warning");
      return;
    }

    const formObj = new FormData();
    Object.keys(formData).forEach((key) => {
      formObj.append(key, formData[key]);
    });
    // ADD THESE EXPLICITLY
    formObj.append("education_type", educationType);
    formObj.append("job_type", jobType);
    formObj.append("experience", formData.experience || "");

    // IMPORTANT
    formObj.append("selected_skills", JSON.stringify(selectedSkills));

    try {
      await axios.post(`${API_BASE_URL}/api/register/`, formObj);
      setIsSubmitted(true);
      showSnack("Registration Successful", "success");
    } catch {
      showSnack("Registration Failed", "error");
    }
  };

  const years = [];
  for (let i = new Date().getFullYear(); i >= 2020; i--) {
    years.push(i);
  }

  // STEP 2: FETCH API

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchSkills = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/get_groupwise_skills/`);
      setGroupSkills(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSkillSelect = (group, skill) => {
    let updated = { ...selectedSkills };

    if (updated[group].includes(skill)) {
      updated[group] = updated[group].filter((s) => s !== skill);
    } else {
      updated[group].push(skill);
    }

    setSelectedSkills(updated);

    // save in formData.skills
    const finalSkills = Object.entries(updated)
      .flatMap(([grp, arr]) => arr.map((skill) => `${grp} - ${skill}`))
      .join(", ");

    setFormData((prev) => ({
      ...prev,
      skills: finalSkills,
    }));
  };

  return (
    <>
      {isSubmitted ? (
        <Box className="thank-you-container">
          <h2>🎉 Thank You for Registration!</h2>
          <p>
            We’ll be in touch if your background matches what we’re looking for.
          </p>
        </Box>
      ) : (
        <Box className="main-container">
          <Box className="card-container">
            {/* LEFT */}
            <Box className="left-panel">
              <div className="overlay">
                <h1 style={{ fontSize: "32px", color: "white" }}>
                  Welcome To
                  <br /> Tapasya Technovation<br></br>
                  <br></br>
                </h1>

                <div className="image-stack-container">
                  <img
                    src="/assets/img1.png"
                    alt="Team"
                    className="stack-img img-bottom"
                  />
                  <img
                    src="/assets/img2.png"
                    alt="Registration"
                    className="stack-img img-top"
                  />
                </div>
                {/* <p> */}
                <h4>
                  Tapasya Technovation delivers innovative solutions in
                  Engineering IoT, Industrial Automation, Embedded Systems,
                  Vision Systems, Robotics and Cybersecurity. Driven by a
                  skilled and forward-thinking team, we build scalable,
                  high-quality solutions that enhance efficiency and
                  performance.
                </h4>
                {/* </p> */}
              </div>
            </Box>

            {/* RIGHT */}
            <Box
              component="form"
              className="right-panel"
              onSubmit={handleSubmit}
            >
              <h2 className="form-title">CANDIDATE REGISTRATION FORM</h2>
              <br />

              <Grid container spacing={2}>
                {/* Row 1: First Name + Last Name (Split 50/50) */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="First Name"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    error={!!errors.first_name}
                    helperText={errors.first_name}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Last Name"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    error={!!errors.last_name}
                    helperText={errors.last_name}
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" }, // stack on mobile, row on desktop
                      gap: 2,
                      alignItems: { xs: "center", sm: "flex-start" },
                      width: "100%",
                    }}
                  >
                    {/* EMAIL CAPTCHA INPUT */}
                    <TextField
                      fullWidth
                      label="Enter Email Captcha"
                      name="emailCaptcha"
                      value={emailCaptcha}
                      onChange={(e) => {
                        const value = e.target.value.slice(
                          0,
                          emailCaptchaText.length,
                        );
                        setEmailCaptcha(value);

                        // ✅ validate live
                        const error = validateField("emailCaptcha", value);
                        setErrors((prev) => ({
                          ...prev,
                          emailCaptcha: error,
                        }));
                      }}
                      error={!!errors.emailCaptcha}
                      helperText={errors.emailCaptcha}
                      required
                    />

                    {/* CAPTCHA CODE + REFRESH BUTTON grouped together */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row", // always side by side
                        gap: 1,
                        alignItems: "center",
                      }}
                    >
                      <canvas id="emailCaptchaCanvas" width={130} height={35} />
                      <Button onClick={generateEmailCaptcha}>↻</Button>
                    </Box>
                  </Box>
                </Grid>

                {/* Row 2: Email (Full Width) */}
                {/* Row 2: Email (Full Width) */}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      flexDirection: { xs: "column", sm: "row" }, // 🔥 KEY CHANGE
                      width: "100%",
                    }}
                  >
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      error={!!errors.email}
                      helperText={errors.email}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          // width: '100%', // Ensures it fills the Grid item
                          minWidth: "220px", // Sets a minimum starting width
                        },
                      }}
                    />

                    {!emailVerified && (
                      <Button
                        variant="contained"
                        onClick={sendEmailCode}
                        disabled={emailSent && timer > 0} // ✅ DISABLE while timer running
                        sx={{
                          height: { xs: "40px", sm: "30px" },
                          width: { xs: "100%", sm: "90px" },
                          background: "#ed7d32",
                          "&:hover": { background: "#1f5fa5" },
                        }}
                      >
                        {emailSent && timer > 0
                          ? formatTime(timer)
                          : emailSent
                            ? "Resend"
                            : "Verify"}
                      </Button>
                    )}
                  </Box>
                </Grid>

                {/* OTP SECTION (IMPORTANT PART) */}
                {emailSent && !emailVerified && (
                  <Grid item xs={12}>
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <TextField
                        fullWidth
                        label="Enter OTP"
                        name="email_code"
                        value={formData.email_code}
                        onChange={handleOtpChange}
                        disabled={otpLoading} // ✅ disable input during loading
                        // inputProps={{ maxLength: 6 }}
                      />

                      {otpLoading ? (
                        <Typography sx={{ color: "blue" }}>
                          Verifying OTP...
                        </Typography>
                      ) : (
                        <Typography sx={{ color: "red", fontWeight: "bold" }}>
                          OTP expires in: {formatTime(timer)}
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                )}
                {/* EMAIL VERIFIED MESSAGE */}
                {emailVerified && (
                  <Grid item xs={12}>
                    <Typography sx={{ color: "green", fontWeight: "bold" }}>
                      Email Verified ✓
                    </Typography>
                  </Grid>
                )}

                {/* Row 3: Phone Number (Full Width) */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    error={!!errors.phone}
                    helperText={errors.phone}
                    required
                  />
                </Grid>

                {/* Row 4: Location (Full Width) */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Address"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    error={!!errors.location}
                    helperText={errors.location}
                    required
                    inputProps={{
                      style: {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl component="fieldset" fullWidth>
                    <RadioGroup
                      row
                      value={educationType}
                      onChange={(e) => setEducationType(e.target.value)}
                      sx={{ width: "100%" }}
                      // sx={{ gap: 7 }} // spacing between options
                    >
                      <FormControlLabel
                        value="pursuing"
                        control={<Radio size="small" />}
                        label="Pursuing"
                      />
                      <FormControlLabel
                        value="completed"
                        control={<Radio size="small" />}
                        label="Completed"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                {educationType === "pursuing" && (
                  <>
                    <Grid item xs={12} sx={{ width: "65%" }}>
                      <TextField
                        fullWidth
                        label="College Name"
                        name="college_name"
                        value={formData.college_name}
                        onChange={handleChange}
                        required
                        error={!!errors.college_name} // ✅ highlight red
                        helperText={errors.college_name}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        select
                        fullWidth
                        label="Current Semester"
                        name="current_sem"
                        value={formData.current_sem || ""}
                        onChange={handleChange}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            minWidth: "220px",
                          },
                        }}
                      >
                        {semesters.map((sem) => (
                          <MenuItem key={sem} value={sem}>
                            {sem}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Select Skills"
                        value={formData.skills}
                        onClick={() => setOpenSkillBox(true)}
                        InputProps={{
                          readOnly: true,
                        }}
                        error={!!errors.skills}
                        helperText={errors.skills}
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Previous Year %"
                        name="last_year_percentage"
                        value={formData.last_year_percentage}
                        onChange={handleChange}
                        // required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        select
                        fullWidth
                        label="Course"
                        name="course_name"
                        value={formData.course_name}
                        onChange={handleChange}
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            // width: '100%', // Ensures it fills the Grid item
                            minWidth: "220px", // Sets a minimum starting width
                          },
                        }}
                      >
                        {courses.map((c) => (
                          <MenuItem key={c} value={c}>
                            {c}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </>
                )}
                {educationType === "completed" && (
                  <>
                    <Grid item xs={12}>
                      <FormControl>
                        <RadioGroup
                          row
                          value={jobType}
                          onChange={(e) => setJobType(e.target.value)}
                          // sx={{ gap: 8 }}
                        >
                          <FormControlLabel
                            value="fresher"
                            control={<Radio size="small" />}
                            label="Fresher"
                          />
                          <FormControlLabel
                            value="experienced"
                            control={<Radio size="small" />}
                            label="Experienced"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        select
                        fullWidth
                        label="Passing Year"
                        name="passing_year"
                        value={formData.passing_year}
                        onChange={handleChange}
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            // width: '100%', // Ensures it fills the Grid item
                            minWidth: "220px", // Sets a minimum starting width
                          },
                        }}
                      >
                        {years.map((y) => (
                          <MenuItem key={y} value={y}>
                            {y}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        select
                        fullWidth
                        label="Course"
                        name="course_name"
                        value={formData.course_name}
                        onChange={handleChange}
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            // width: '100%', // Ensures it fills the Grid item
                            minWidth: "220px", // Sets a minimum starting width
                          },
                        }}
                      >
                        {courses.map((c) => (
                          <MenuItem key={c} value={c}>
                            {c}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {/* <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Skills"
                        name="skills"
                        value={formData.skills}
                        onChange={handleChange}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            // width: '100%', // Ensures it fills the Grid item
                            minWidth: "220px", // Sets a minimum starting width
                          },
                        }}
                      />
                    </Grid> */}

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Select Skills"
                        value={formData.skills}
                        onClick={() => setOpenSkillBox(true)}
                        InputProps={{
                          readOnly: true,
                        }}
                        error={!!errors.skills}
                        helperText={errors.skills}
                        required
                      />
                    </Grid>

                    {jobType === "experienced" && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Experience (Years)"
                          name="experience"
                          value={formData.experience || ""}
                          onChange={handleChange}
                          error={!!errors.experience}
                          helperText={errors.experience}
                          required
                        />
                      </Grid>
                    )}
                  </>
                )}

                {/* Row 9: Resume Upload (Full Width) */}
                <Grid item xs={12}>
                  <Box className="file-upload-wrapper">
                    <label className="file-label">
                      Upload Resume
                      <input
                        type="file"
                        hidden
                        name="resume"
                        // accept=".pdf,.doc,.docx"
                        onChange={handleChange}
                        required
                      />
                    </label>
                    <span className="file-name">
                      {formData.resume
                        ? formData.resume.name
                        : "No file selected *"}
                    </span>
                  </Box>
                  {/* ✅ ADD ERROR HERE */}
                  {errors.resume && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.resume}
                    </span>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" }, // stack on mobile, row on desktop
                      gap: 2,
                      alignItems: { xs: "center", sm: "flex-start" },
                      width: "100%",
                    }}
                  >
                    {/* CAPTCHA INPUT */}
                    <TextField
                      fullWidth
                      label="Enter Captcha"
                      name="captcha"
                      value={formData.captcha}
                      onChange={handleChange}
                      error={!!errors.captcha}
                      helperText={errors.captcha}
                      required
                    />

                    {/* CAPTCHA CODE + REFRESH BUTTON grouped together */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row", // always side by side
                        gap: 1,
                        alignItems: "center",
                      }}
                    >
                      <canvas
                        id="mainCaptchaCanvas"
                        width={140}
                        height={35}
                        style={{ borderRadius: "0px" }}
                      />
                      <Button
                        onClick={generateCaptcha}
                        sx={{
                          minWidth: "50px",
                          height: "40px",
                          fontSize: "18px",
                        }}
                      >
                        ↻
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              {/* SUBMIT */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 3,
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  className="full-btn"
                  disabled={!checkAllValid()}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snack.message}
        </Alert>
      </Snackbar>

      {openSkillBox && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 1,
          }}
        >
          <Box
            sx={{
              width: { xs: "95%", sm: "80%", md: "65%" },
              maxWidth: "500px",
              maxHeight: { xs: "75vh", sm: "80vh" },
              background: "#fff",
              borderRadius: "12px",
              boxShadow: 10,
              overflowY: "auto",
              p: 2,
              position: "relative",
            }}
          >
            {/* ❌ CLOSE BUTTON */}
            <Button
              onClick={() => setOpenSkillBox(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                minWidth: "30px",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                fontSize: "18px",
                color: "#333",
              }}
            >
              ✕
            </Button>
            <Typography
              variant="h6"
              sx={{
                fontSize: "18px",
                fontWeight: "bold",
                textAlign: "center",
                mb: 2,
              }}
            >
              Select Skills
            </Typography>

            <Grid container spacing={2}>
              {groupSkills.map((group) => (
                <Grid item xs={12} key={group.group}>
                  <Box
                    sx={{
                      border: "1px solid #ddd",
                      p: 1.5,
                      borderRadius: "8px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        mb: 1,
                        color: "#EE7F1A",
                      }}
                    >
                      {group.group}
                    </Typography>

                    {group.skills.map((skill) => (
                      <FormControlLabel
                        key={skill}
                        control={
                          <Checkbox
                            size="small"
                            checked={selectedSkills[group.group]?.includes(
                              skill,
                            )}
                            onChange={() =>
                              handleSkillSelect(group.group, skill)
                            }
                          />
                        }
                        label={
                          <Typography sx={{ fontSize: "13px" }}>
                            {skill}
                          </Typography>
                        }
                      />
                    ))}
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Box mt={2} textAlign="center">
              <Button
                variant="contained"
                onClick={() => setOpenSkillBox(false)}
                sx={{
                  background: "#EE7F1A",
                  px: 4,
                  "&:hover": { background: "#1f5fa5" },
                }}
              >
                Done
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Register;
